import MarkdownIt from 'markdown-it';
import {
  MessageMarkdownSerializer,
  MessageMarkdownTransformer,
} from '@chatwoot/prosemirror-schema';
import { stripUnsupportedFormatting } from './editorHelper';

const MENTION =
  /\[((?:\\.|[^\]\\])*)\]\(mention:\/\/whatsapp\/(\d+@(?:s\.whatsapp\.net|lid))\/([^\s()]*)\)/g;

// Use the upstream serializer for everything except the new external mention type.
const MarkdownSerializer = MessageMarkdownSerializer.constructor;
const serializer = new MarkdownSerializer(
  {
    ...MessageMarkdownSerializer.nodes,
    mention(state, node) {
      if (node.attrs.mentionType !== 'whatsapp') {
        MessageMarkdownSerializer.nodes.mention(state, node);
        return;
      }
      const name = node.attrs.userFullName || '';
      const encoded = encodeURIComponent(name).replace(
        /[!'()*]/g,
        character => `%${character.charCodeAt(0).toString(16).toUpperCase()}`
      );
      state.write(
        `[${state.esc('@' + name)}](mention://whatsapp/${node.attrs.userId}/${encoded})`
      );
    },
  },
  MessageMarkdownSerializer.marks
);

export const serializeWhatsAppEditorContent = doc => serializer.serialize(doc);

export function parseWhatsAppEditorContent(content, schema) {
  const source = content || '';
  // The API-channel sanitizer strips ordinary links. Preserve only our typed
  // tokens, so a saved draft retains the identity selected by the operator.
  let cursor = 0;
  let sanitized = '';
  Array.from(source.matchAll(MENTION)).forEach(match => {
    sanitized +=
      stripUnsupportedFormatting(source.slice(cursor, match.index), schema) +
      match[0];
    cursor = match.index + match[0].length;
  });
  sanitized += stripUnsupportedFormatting(source.slice(cursor), schema);

  const tokenizer = new MarkdownIt('commonmark', {
    html: false,
    linkify: false,
  });
  tokenizer.disable(['table', 'hr', 'heading', 'lheading'], true);
  tokenizer.inline.ruler.before('link', 'whatsapp_mention', (state, silent) => {
    if (state.src[state.pos] !== '[') return false;
    const match = new RegExp('^(?:' + MENTION.source + ')').exec(
      state.src.slice(state.pos)
    );
    if (!match || match.index !== 0) return false;
    let name;
    try {
      name = decodeURIComponent(match[3]);
    } catch {
      return false;
    }
    if (!silent) {
      const token = state.push('mention', '', 0);
      token.mention = {
        userId: match[2],
        userFullName: name,
        mentionType: 'whatsapp',
      };
    }
    state.pos += match[0].length;
    return true;
  });
  return new MessageMarkdownTransformer(schema, tokenizer).parse(sanitized);
}
